import DEFAULT_BRAND from './branding';

let CURRENT_BRAND = DEFAULT_BRAND;

export const setBranding = (brand) => {
  CURRENT_BRAND = {
    ...DEFAULT_BRAND,
    ...(brand || {}),
    pdfHeader: { ...(DEFAULT_BRAND.pdfHeader || {}), ...((brand || {}).pdfHeader || {}) },
  };
};

export const getBranding = () => CURRENT_BRAND;

export const getBrandingForEmployee = (employee) => {
  // Déterminer le branding selon le site de l'employé
  const siteName = employee?.site?.name?.toLowerCase() || '';
  
  if (siteName.includes('tenes')) {
    // Utiliser les configurations spécifiques à Tenes
    return {
      ...CURRENT_BRAND,
      pdfLogo: CURRENT_BRAND.pdfLogoTenes || CURRENT_BRAND.pdfLogo,
      pdfHeader: CURRENT_BRAND.pdfHeaderTenes || CURRENT_BRAND.pdfHeader,
    };
  }
  
  // Par défaut (Boufarik ou autre), utiliser les configurations principales
  return CURRENT_BRAND;
};

export default { getBranding, setBranding, getBrandingForEmployee };
